import { showLoading, hideLoading } from './utils';
import Alert from './alert';
import $ from 'jquery';
import Modal from './modal';
import Watchlist from './watchlist';
import Sorter from './sorter';

var Start = {
  form        : null,
  results     : null,
  pageList    : [],
  request     : null,

  orderInput  : null,
  sortInput   : null,

  order       : null,
  sortBy      : null,

  init: function() {
    this.form     = $('#search-form');
    this.results  = $('#search-results');

    this.orderInput = this.form.find('input[name=order]');
    this.sortInput  = this.form.find('input[name=sort]');

    if(this.form.length !== 0) {
      this.bindFunctions();
      this.bindEvents();

      this.loadMakers();
      this.loadModels();

      this.checkHash();
    }
  },

  bindFunctions: function() {
    $.fn.ajaxWithMessage    = this.ajaxMessage;
    $.fn.getAvailableMakers = this.getAvailableMakers;
    $.fn.getAvailableModels = this.getAvailableModels;
    $.fn.selectCurrentOrPreviousDates = this.selectCurrentOrPreviousDates;
  },

  bindEvents: function() {
    $('#maker-select').getAvailableModels('change');
    $('#auction-select').getAvailableMakers('change');
    $('.date-select').getAvailableMakers('click');
    $('ul.auction-list input').selectCurrentOrPreviousDates('change');
    $("#save-search").ajaxWithMessage('/saved-searches/save', 'Your search has been saved');
    $("#email-results").ajaxWithMessage('/saved-searches/save?email=1', 'Your results will now be emailed to you once or twice daily');

    this.form.on('submit', this.submitSearch.bind(this));
  },

  // Load Makers
  loadMakers: function() {
    var makers = Start.form.find('#maker-select');
    if (makers.length < 1) return;

    makers.html("<option value=''>Loading Makers</option>");
    $.getJSON('/start/makers.json', Start.form.serialize(), function(data) {
      var options = "<option value=''>Select Maker</option>";

      data.forEach(function(item, i, array) {
        options += "<option value='" + item.maker + "'>" + item.maker + "</option>\n";
      });

      makers.html(options);
    });
  },

  selectCurrentOrPreviousDates: function(event) {
    $(this).on(event, function(e) {
      if ($(this).closest('ul').hasClass('previous') && $('ul.current input:checked').length > 0) {
        $('ul.current input').each(function() {
          $(this).removeAttr('checked');
        });
      } else if ($(this).closest('ul').hasClass('current') && $('ul.previous input:checked').length > 0) {
        $('ul.previous input').each(function() {
          $(this).removeAttr('checked');
        });
      }
    });
  },

  loadModels: function() {
    var makers = Start.form.find('#maker-select');
    var models = Start.form.find('#model-select');

    if (makers.length < 1) return;

    showLoading();
    models.html("<option value=''>Loading Models</option>");
    if( makers.val() !== '' ) {
      $.getJSON('/start/models.json', Start.form.serialize(), function(data) {
        var options = "<option value=''>Select Model</option>";

        data.forEach(function(item, i, array) {
          options += "<option value='" + item.model + "'>" + item.model + "</option>\n";
        });

        models.html(options);
        hideLoading();
      });
    } else {
      models.html("<option value=''>Model - select maker first</option>");
      hideLoading();
    }
  },

  submitSearch: function(e) {
    e.preventDefault();

    if(Start.request !== null) {
      Start.request.abort();
    }

    showLoading();
    Start.request = $.post(this.form.attr('action'), this.form.serialize(), function(data) {
      Start.results.html(data);
      hideLoading();

      Start.updatePageList();
      Start.markActiveOrder();
      Modal.bind();
      Watchlist.bind();
      Sorter.init({ onFinish: Start.onSorterFinish });
    });
  },

  markActiveOrder: function() {
    var toggles = Start.results.find('[data-toggle=sorter]');

    var activeToggle = toggles.filter(function() {
      return $(this).data('sort-by') === Start.sortBy;
    });

    activeToggle.addClass('is-active is-' + Start.order);
  },

  onSorterFinish: function() {
    Start.order     = this.activeOrder;
    Start.sortBy    = this.activeToggle;

    Start.orderInput.val(Start.order);
    Start.sortInput.val(Start.sortBy);

    Start.updatePageList();
  },

  updatePageList: function() {
    Start.pageList = [];

    Start.results.find('.result').each(function(index) {
      Start.pageList.push($(this).data('id'));
    });
  },

  checkHash: function() {
    if(window.location.hash != '') {
      Modal.id = window.location.hash.replace('#', '');

      showLoading();
      $.get('/cardetail/?id=' + Modal.id, Modal.replaceContent);
    }
  },

  getAvailableMakers: function(event) {
    $(this).on(event, Start.loadMakers);
  },

  getAvailableModels: function(event) {
    $(this).on(event, Start.loadModels);
  },

  ajaxMessage: function(url, message) {
    $(this).on('click', function(){
      showLoading();
      $.post(url, Start.form.serialize(), function(data) {
        hideLoading();
        Alert.show({ level: 'success', message: data + message });
      });
    });
  }
};

export default Start;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/start.js